function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #959595;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "moda",
  transform: "translate(-248.331 -320.839)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_41",
  "data-name": "Trazado 41",
  className: "cls-1",
  d: "M270.835,324.624a4.45,4.45,0,0,0,4.239-3.071,17.9,17.9,0,0,1-8.477,0A4.45,4.45,0,0,0,270.835,324.624Z",
  transform: "translate(-6.104)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_42",
  "data-name": "Trazado 42",
  className: "cls-1",
  d: "M281.092,325.236a.752.752,0,0,0-.391-.43l-6.254-2.887a30.177,30.177,0,0,0-4.053-1.067.746.746,0,0,0-.144-.014.735.735,0,0,0-.718.577,4.919,4.919,0,0,1-9.6,0,.735.735,0,0,0-.717-.577.747.747,0,0,0-.144.014,30.263,30.263,0,0,0-4.056,1.067l-6.251,2.887a.741.741,0,0,0-.35,1.009l2.715,5.358a.737.737,0,0,0,.872.375l3.016-.893v17.977a.743.743,0,0,0,.742.741h17.95a.741.741,0,0,0,.74-.741V330.655l3.018.894a.737.737,0,0,0,.872-.376l2.716-5.357A.748.748,0,0,0,281.092,325.236Z",
  transform: "translate(0 0)"
}));

function SvgModa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.801,
    height: 28.534,
    viewBox: "0 0 32.801 28.534",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModa);
export default __webpack_public_path__ + "static/media/moda.25330fd3.svg";
export { ForwardRef as ReactComponent };